import { HttpClient, provideHttpClient, withInterceptors, withXhr, type HttpInterceptorFn } from '@angular/common/http';
import { EnvironmentInjector, InjectionToken, createEnvironmentInjector, inject, type Provider } from '@angular/core';

/** The host app's interceptor chain for uploads. No silent default: a client without auth would upload anonymously. */
export const UPLOAD_HTTP_INTERCEPTORS = new InjectionToken<readonly HttpInterceptorFn[]>('UPLOAD_HTTP_INTERCEPTORS', {
  providedIn: 'root',
  factory: (): readonly HttpInterceptorFn[] => {
    throw new Error('UPLOAD_HTTP_INTERCEPTORS is not provided: pass the app chain to provideUploadHttpInterceptors()');
  },
});

// The app-wide client runs on the fetch backend, which emits no upload progress and so turns the idle timeout into a hard cap.
export const UPLOAD_HTTP_CLIENT = new InjectionToken<HttpClient>('UPLOAD_HTTP_CLIENT', {
  providedIn: 'root',
  factory: (): HttpClient =>
    createEnvironmentInjector(
      [provideHttpClient(withXhr(), withInterceptors([...inject(UPLOAD_HTTP_INTERCEPTORS)]))],
      inject(EnvironmentInjector),
    ).get(HttpClient),
});

export function provideUploadHttpInterceptors(chain: readonly HttpInterceptorFn[]): Provider {
  return { provide: UPLOAD_HTTP_INTERCEPTORS, useValue: chain };
}
